import { Loader2 } from '../../icons';
import * as React from 'react';

interface PageLoaderProps {
  /** Optional message shown below the spinner. */
  message?: string;
}

/**
 * Full-screen loading state — used as the Suspense fallback in App.tsx
 * and as the loading gate while Firebase restores the auth session.
 */
export function PageLoader({ message }: PageLoaderProps): React.ReactElement {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-muted">
      <Loader2 size={32} className="animate-spin text-muted-foreground" />
      {message && <p className="text-body-sm-medium text-muted-foreground">{message}</p>}
    </div>
  );
}
